import { useState, useEffect } from 'react'
import { Button, Card, message, Modal, Upload, Input, Spin, Tooltip, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
	PlusOutlined,
	UploadOutlined,
	QuestionCircleOutlined
} from '@ant-design/icons';
import styles from './index.module.scss';
import AudioPlayerCard from '../components/AudioPlayCard';
import { getPublicVoiceList, getMyVoiceList } from '../../api/voice';
import { AxiosResponse } from 'axios';
import type { VoiceItem } from '../../types/voice';
import { RcFile } from 'antd/es/upload/interface';
import AudioPlayer from '../components/AudioPlayer';
import type { GetProp, UploadProps, UploadFile } from 'antd';
import { sqlInjectionPattern } from '../../utils';
import { createReferAudio, getReferAudioSeat } from '../../api/voice';
import ImageDisplayModal from '../components/ImageDisplayModal';
import WeCom from '../../assets/images/wecom.jpg';
import { useTranslation } from 'react-i18next';

const Voice = () => {
	const { TextArea } = Input;
	type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

	const navigate = useNavigate();
	const [publicVoiceList, setPublicVoiceList] = useState<VoiceItem[]>([])
	const [myVoiceList, setMyVoiceList] = useState<VoiceItem[]>([])
	const [currentPlayingId, setCurrentPlayingId] = useState<number | null>(null);
	const [versionModalVisible, setVersionModalVisible] = useState<boolean>(false);
	const [selectedVersion, setSelectedVersion] = useState<string>('');
	const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
	const [audioFile, setAudioFile] = useState<FileType | undefined>(undefined);
	const [audioText, setAudioText] = useState<string>('');
	const [audioDuration, setAudioDuration] = useState<number>(0);
	const [loadings, setLoadings] = useState<boolean[]>([false, false])
	const [currentLang, setCurrentLang] = useState<string | undefined>(undefined)
	const [isWeComVisible, setIsWeComVisible] = useState<boolean>(false)
	const [langHasError, setLangHasError] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		fetchMyVoiceList()
		fetchPublicVoiceList()
	}, [])


	const handlePlayStateChange = (voiceId: number | null) => {
		setCurrentPlayingId(voiceId);
	};

	const handleUseButtonClick = (voice: VoiceItem) => {
		navigate(
			'/console/clone/videoCreate',
			{
				state: {
					id: voice.id,
					name: voice.name,
					audioUrl: voice.audioUrl,
					from: 'voice'
				}
			}
		);
	};

	const enterLoading = (index: number, status: boolean = true) => {
		setLoadings((prevLoadings) => {
			const newLoadings = [...prevLoadings];
			newLoadings[index] = status;
			return newLoadings;
		});
	}

	const fetchPublicVoiceList = () => {
		getPublicVoiceList({}).then((res: AxiosResponse) => {
			if (res.data.status === 200) {

				setPublicVoiceList(res.data.data)
			}
		})
	}

	const fetchMyVoiceList = () => {
		getMyVoiceList({}).then((res: AxiosResponse) => {
			if (res.data.status === 200) {
				setMyVoiceList(res.data.data)
			}
		})
	}

	const handleVersionSelect = async (version: string) => {
		

		if (version === '极致版' || version === '高级版') {
			// message.info('联系客服咨询')
			setIsWeComVisible(true)
			return
		}

		try {
			enterLoading(1)
			const result = await getReferAudioSeat({})
			const { status } = result.data

			if (status === 200) {
				setCurrentLang(undefined)

				setSelectedVersion(version);
				setVersionModalVisible(false);
				setUploadModalVisible(true);
			} else if (status === 1009) {
				Modal.warning({
					centered: true,
					title: '提示',
					content: '超出当前套餐数量限制，需要释放一个已克隆的声音'
				})
			}
			enterLoading(1, false)
		} catch (err) {
			enterLoading(1, false)
		} finally {

		}


	};

	const handleUploadCancel = () => {
		setUploadModalVisible(false);
		setAudioFile(undefined);
		setAudioText('');
		setSelectedVersion('');
	};

	const handleAudioSubmit = async () => {
		if (!audioFile) {
			message.warning('请选择音频文件');
			return;
		}

		if (!audioText.trim()) {
			message.warning('请输入音频文件内的文字');
			return;
		}

		if (!currentLang) {
			message.warning('请选择音频内容所属语言')
			setLangHasError(true)
			return 
		}

		// setUploadingAudio(true);
		enterLoading(0)
		try {

			const result = await createReferAudio({
				'sourceFile': audioFile,
				'voiceText': audioText,
				'language': currentLang
			})
			const { status } = result.data
			if (status === 200) {

				Modal.success({
					centered: true,
					title: '提示',
					content: '音频克隆成功，快去使用创作吧'
				})


				fetchMyVoiceList()
				handleUploadCancel();
			} else if (status === 1009) {
				Modal.warning({
					centered: true,
					title: '提示',
					content: '超出当前套餐数量限制，需要释放一个已克隆的声音'
				})

			}
			enterLoading(0, false)
			

		} catch (error) {
			message.error('处理失败，请稍后重试');
			// setUploadingAudio(false);
			enterLoading(0, false)
		} finally {

		}
	};

	const getAudioDuration = (file: File): Promise<number> => {
		return new Promise((resolve) => {
			const audio = new Audio();
			audio.onloadedmetadata = () => {
				resolve(audio.duration);
			};
			audio.src = URL.createObjectURL(file);
		});
	};

	const handleAudioFileUpload = async (file: FileType) => {
		const isAudio = file.type.startsWith('audio/');
		if (!isAudio) {
			message.error('请上传音频文件！');
			return false;
		}

		const isLt10M = file.size / 1024 / 1024 < 100;
		if (!isLt10M) {
			message.error('音频文件大小不能超过100MB！');
			return false;
		}
		const duration = await getAudioDuration(file);

		if (duration > 10 || duration < 4) {
			message.warning(`音频时长超过4～10秒, 当前时长${duration}秒`)
			return false;
			// return false;
		}
		setAudioFile(file)
		setAudioDuration(duration)

		return false; // 阻止自动上传
	};

	const handleAudioText = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

		const audioText = e.target.value
		if (sqlInjectionPattern.test(audioText)) {
			message.error('输入内容不能包含特殊字符');
			return false;
		}
		setAudioText(audioText)
	}

	const handleUpdateAudioName = () => {
		fetchMyVoiceList()
	}

	const handleDeleteAudio = () => {
		fetchMyVoiceList()
	}

	const handleLangaugeChange = (value: string) => {
		// console.log(value)
		setCurrentLang(value)
		setLangHasError(false)
	}

	return (
		<>
			<div className={styles.section}>
				<div className={styles.sectionHeader}>
					<div className={styles.title}>{t('voice.title1')}</div>

				</div>
				<div className={styles.voiceGrid}>
					<Card
						className={styles.addCard}
						hoverable
						onClick={() => setVersionModalVisible(true)}>
						<PlusOutlined />
						
					</Card>
					{myVoiceList.map((voice) => (
						<AudioPlayerCard
							key={voice.id}
							voice={voice}
							currentPlayingId={currentPlayingId}
							onPlayStateChange={handlePlayStateChange}
							onUseButtonClick={handleUseButtonClick}
							onUpdateName={handleUpdateAudioName}
							onDeleteAudio={handleDeleteAudio}
						/>
					))}
				</div>
			</div>

			<Modal
				title={t('voice.modal1.title')}
				open={versionModalVisible}
				onCancel={() => setVersionModalVisible(false)}
				footer={null}
				className={styles.versionModal}
				centered
				width={560}
			>
				<div className={styles.versionCards}>

					<div
						className={styles.versionCard}
						onClick={() => handleVersionSelect('免费版')}
					>
						<Spin spinning={loadings[1]}>
							<div className={styles.versionTitle}>{t('voice.modal1.free_plan.title')}</div>
							<div className={styles.versionDesc}>{t('voice.modal1.free_plan.description')}</div>
							<div className={styles.versionFeatures}>
								<div>• {t('voice.modal1.free_plan.item1')}</div>
								<div>• {t('voice.modal1.free_plan.item2')}</div>
							</div>
						</Spin>
					</div>

					<div
						className={`${styles.versionCard} ${styles.premiumCard}`}
						onClick={() => handleVersionSelect('高级版')}
					>
						<div className={styles.versionTitle}>{t('voice.modal1.advance_plan.title')}</div>
						<div className={styles.versionDesc}>
							<span className={styles.oldPrice}>{t('voice.modal1.advance_plan.price')}</span>
							<div className={styles.newPrice}>{t('voice.modal1.advance_plan.promotional')} / {t('voice.modal1.per_person')}</div>
						</div>

						<div className={styles.versionDesc}>{t('voice.modal1.advance_plan.description')}</div>
						<div className={styles.versionFeatures}>
							<div>• {t('voice.modal1.advance_plan.item1')}</div>
							<div>• {t('voice.modal1.advance_plan.item2')}</div>
						</div>
						<div className={styles.comingSoon}>{t('voice.modal1.advance_plan.popular')}</div>
					</div>

					<div
						className={`${styles.versionCard} ${styles.premiumCard}`}
						onClick={() => handleVersionSelect('极致版')}
					>
						<div className={styles.versionTitle}>{t('voice.modal1.final_plan.title')}</div>
						<div className={styles.versionDesc}>
							<span className={styles.oldPrice}>{t('voice.modal1.final_plan.price')}</span>
							<div className={styles.newPrice}>{t('voice.modal1.final_plan.promotional')} / {t('voice.modal1.per_person')}</div>
						</div>
						<div className={styles.versionDesc}>{t('voice.modal1.final_plan.description')}</div>
						<div className={styles.versionFeatures}>
							<div>• {t('voice.modal1.final_plan.item1')}</div>
							<div>• {t('voice.modal1.final_plan.item2')}</div>
						</div>

					</div>
				</div>
			</Modal>

			<Modal
				title={t('voice.modal2.title')}
				open={uploadModalVisible}
				onCancel={handleUploadCancel}
				footer={[
					<Button key="cancel" onClick={handleUploadCancel}>
						{t('voice.modal2.cancel')}
					</Button>,
					<Button
						key="submit"
						type="primary"
						loading={loadings[0]}
						onClick={handleAudioSubmit}
					>
						{t('voice.modal2.submit')}
					</Button>
				]}
				className={styles.uploadModal}
				width={610}
			>
				<div className={styles.uploadContent}>
					<div className={styles.uploadTip}>{t('voice.modal2.description')}</div>
					<div className={styles.voiceSection}>
						<div className={styles.uploadSection}>
							<Upload
								beforeUpload={handleAudioFileUpload}
								accept=".wav, .flac"
								showUploadList={false}
								className={styles.uploadArea}
								disabled={loadings[0]}
							>
								<div className={styles.uploadBox}>
									{audioFile ? (
										<div className={styles.fileInfo}>
											<UploadOutlined className={styles.uploadIcon} />
											<div className={styles.fileName}>{audioFile.name}</div>
											<div className={styles.fileSize}>
												{(audioFile.size / 1024 / 1024).toFixed(2)} MB
											</div>
										</div>
									) : (
										<div className={styles.uploadPlaceholder}>
											<UploadOutlined className={styles.uploadIcon} />
											<div>{t('voice.modal2.select_voice')}</div>
											<div className={styles.uploadAreaTip}>{t('voice.modal2.voice_format')}</div>
										</div>
									)}
								</div>
							</Upload>


						</div>
						<AudioPlayer src={audioFile} />
					</div>


					<div className={styles.textSection}>
						<div className={styles.tipArea}>
							<div className={styles.textLabel}>{t('voice.modal2.refer_text')}</div>
							<div className={styles.language}>
								<div className={styles.tip}>
									{t('voice.modal2.current_lang')}
									{" "}
									<Tooltip title={t('voice.modal2.language_tip')}>
										<QuestionCircleOutlined />
									</Tooltip>
								</div>


								<Select
									value={currentLang}
									placeholder={t('voice.modal2.select_lang')}								
									className={styles.select}
									status={langHasError? 'error': ''}
									onChange={handleLangaugeChange}
									options={[
										
										
										{ value: 'en', label: t('languages.en') },
										{ value: 'all_ja', label: t('languages.ja') },
										{ value: 'all_ko', label: t('languages.ko') },
										{ value: 'all_yue', label: t('languages.yue') },
										{ value: 'all_zh', label: t('languages.zh') },
									
									]}
									disabled={loadings[0]}
								/>
							</div>
						</div>

						<TextArea
							value={audioText}
							onChange={handleAudioText}
							placeholder={t('voice.modal2.input_placehoder')}
							rows={6}
							className={styles.textArea}
							maxLength={1000}
							showCount
							disabled={loadings[0]}
						/>
					</div>
				</div>
			</Modal>

			<ImageDisplayModal
				isVisible={isWeComVisible}
				onClose={() => setIsWeComVisible(false)}
				imageUrl={WeCom}
				imageAlt=""
				imageWidth={300}
				preview={false}  
				title="扫码咨询定制" 
			/>

			<div className={styles.section}>
				<div className={styles.sectionHeader}>
					<div className={styles.title}>{t('voice.title2')}</div>
				</div>
				<div>
					<div className={styles.voiceGrid}>
						{
							publicVoiceList.map((voice: VoiceItem) => (
								<AudioPlayerCard
									key={voice.id}
									voice={voice}
									currentPlayingId={currentPlayingId}
									onPlayStateChange={handlePlayStateChange}
									onUseButtonClick={handleUseButtonClick}
								/>
							))
						}
					</div>
				</div>
			</div>
		</>

	)
}

export default Voice;